import React from 'react'
import { buildFileUrl } from '../../config/strapi'


interface FirstSectionCardProps {
  card: any
}

export function FirstSectionCard({ card }: FirstSectionCardProps) {
  if (!card) return null

  const header = card.Header
  const button = card.Button
  const backgroundUrl = card.background?.url
    ? buildFileUrl(card.background.url)
    : undefined
  const conts = card.Cont || []

  return (
    <section
      style={{
        position: 'relative',
        width: '100%',
        minHeight: '50vh',
        background: backgroundUrl
          ? `url(${backgroundUrl}) center/cover no-repeat, linear-gradient(135deg, #007bff 0%, #005fa3 100%)`
          : 'linear-gradient(135deg, #007bff 0%, #005fa3 100%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        padding: 0,
        overflow: 'hidden',
        marginBottom: '40px',
      }}
    >
      {/* Texto no canto superior direito */}
      <div
        style={{
          position: 'absolute',
          top: 'clamp(12px, 3vw, 24px)',
          right: 'clamp(12px, 2vw, 24px)',
          zIndex: 3,
          padding: 'clamp(8px, 1.5vw, 16px) clamp(10px, 1.5vw, 16px)',
        }}
      >
        <span style={{
          fontSize: 'clamp(10px, 2.5vw, 15px)',
          fontWeight: 400,
          color: 'white',
          letterSpacing: 0.5,
        }}>
          Foto tirada por: Denis Ferreira Neto
        </span>
      </div>

      {/* Conteúdo principal */}
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          width: '100%',
          padding: 'clamp(24px, 6vw, 48px) clamp(16px, 5vw, 7vw) 0',
          minHeight: 'calc(80vh - 200px)',
          gap: 'clamp(12px, 3vw, 20px)',
        }}
      >
        {/* Texto à esquerda */}
        <div style={{
          maxWidth: 'min(600px, 85vw)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          marginTop: 'clamp(24px, 6vw, 48px)',
          gap: 'clamp(12px, 2.5vw, 18px)',
        }}>
          <h1 style={{
            fontSize: 'clamp(24px, 5vw, 40px)',
            fontWeight: 900,
            margin: 0,
            color: 'white',
            textAlign: 'left',
            letterSpacing: 1,
            lineHeight: 1.2,
            textShadow: '0 1px 4px rgba(0,0,0,0.15)',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
          }}>
            {header?.title}
          </h1>
          <p style={{
            fontSize: 'clamp(14px, 3vw, 18px)',
            margin: 0,
            maxWidth: 'min(460px, 85vw)',
            color: 'white',
            textAlign: 'left',
            letterSpacing: 1,
            textShadow: '0 1px 4px rgba(0,0,0,0.1)',
            lineHeight: 1.4,
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
          }}>
            {header?.subtitle}
          </p>
          {button && (
            <a
              href={button.link}
              style={{
                display: 'inline-block',
                padding: 'clamp(10px, 2vw, 14px) clamp(16px, 3vw, 24px)',
                background: '#1976d2',
                color: 'white',
                borderRadius: 6,
                fontWeight: 600,
                fontSize: 'clamp(13px, 2.5vw, 16px)',
                textDecoration: 'none',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                marginTop: 'clamp(8px, 2vw, 12px)',
                transition: 'all 0.2s ease',
                textAlign: 'center',
                minWidth: 'fit-content',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#1565c0'
                e.currentTarget.style.transform = 'translateY(-1px)'
                e.currentTarget.style.boxShadow = '0 3px 8px rgba(0,0,0,0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#1976d2'
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)'
              }}
            >
              {button.title}
            </a>
          )}
        </div>
      </div>

      {/* Faixa branca curva */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: 'clamp(120px, 15vw, 180px)',
          zIndex: 2,
          pointerEvents: 'none',
          marginTop: 'auto',
        }}
      >
        <svg
          viewBox="0 0 1140 200"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          style={{ display: 'block' }}
        >
          <path
            d="M0,90 Q100,300 720,100 Q1000,0 1200,0 L1440,20 L0,900 Z"
            fill="white"
          />
        </svg>
      </div>

      {/* Cards dos contadores - responsivo */}
      <div
        className="first-section-counters"
        style={{
          position: 'absolute',
          right: 'clamp(16px, 5vw, 7vw)',
          bottom: 'clamp(10px, 2vw, 10px)',
          zIndex: 3,
          display: 'flex',
          flexDirection: 'row',
          gap: 'clamp(16px, 3vw, 24px)',
          pointerEvents: 'auto',
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          maxWidth: 'calc(100% - clamp(32px, 10vw, 14vw))',
        }}
      >
        {conts.map((cont: any, idx: number) => (
          <div
            key={idx}
            style={{
              color: '#222',
              padding: 'clamp(16px, 1vw, 14px) clamp(10px, 2vw, 12px)',
              minWidth: 'clamp(140px, 20vw, 180px)',
              maxWidth: 'clamp(180px, 25vw, 220px)',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: 'none',
              fontWeight: 600,
              fontSize: 'clamp(16px, 2.5vw, 20px)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)'
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.0'
            }}
          >
            <div style={{ 
              fontSize: 'clamp(20px, 3.5vw, 28px)',
              fontWeight: 700,
              marginBottom: 'clamp(4px, 1vw, 6px)',
              lineHeight: 1.1,
            }}>{cont.title}</div>
            <div style={{ 
              fontSize: 'clamp(12px, 2vw, 16px)',
              color: '#555',
              fontWeight: 500,
              lineHeight: 1.2,
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
            }}>{cont.subtitle}</div>
          </div>
        ))}
      </div>
      {/* Overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: backgroundUrl ? 'rgba(0,0,0,0.12)' : 'none',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
      <style>{`
        @media (max-width: 900px) {
          .first-section-counters {
            bottom: 0px !important;
          }
        }
      `}</style>
    </section>
  )
} 